import React from 'react';
import { Typography, Link, Tile, TileText, TileMedia, } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { Controller } from 'react-hook-form';
import { FooterButtons } from '../footer-buttons';
import { PaymentPermissionsDrawer } from './payment-permissions-drawer';
import { useDrawer } from '../../../../hooks/use-drawer';
import { useManageUserForm } from '../../../../hooks/use-manage-user-form';
export var PaymentPermissionsSection = function (_a) {
    var isActive = _a.isActive, isCompleted = _a.isCompleted, shouldDisableEditing = _a.shouldDisableEditing, continueHandler = _a.continueHandler, editHandler = _a.editHandler, cancelHandler = _a.cancelHandler;
    var _b = useManageUserForm(), formMethods = _b.formMethods, PTCs = _b.PTCs;
    var control = formMethods.control, watch = formMethods.watch;
    var paymentPermissions = watch('paymentPermissions');
    var userPermissionsTxt = paymentPermissions.length
        ? "Pro Trade Credit (".concat(paymentPermissions.length, " selected)")
        : 'None selected';
    var _c = useDrawer(), openDrawer = _c.openDrawer, hideDrawer = _c.hideDrawer;
    if (!PTCs) {
        return null;
    }
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8 sui-mb-4" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                React.createElement(Typography, { variant: "h5", color: isActive || isCompleted ? 'primary' : 'inactive' }, "Payment Permissions"),
                isCompleted && (React.createElement(Link, { "data-testid": "permissions-edit-btn", component: "button", className: shouldDisableEditing
                        ? 'sui-text-inactive sui-pointer-events-none sui-opacity-60 sui-text-base'
                        : 'sui-text-base sui-font-regular sui-text-primary sui-underline', onClick: shouldDisableEditing ? undefined : editHandler, "aria-disabled": shouldDisableEditing }, "Edit"))),
            isCompleted && React.createElement(Typography, null, userPermissionsTxt),
            isActive && (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(Typography, null, "Select the payment methods this user should have access to."),
                React.createElement("div", { className: "sui-flex" },
                    React.createElement(Controller, { name: "paymentPermissions", control: control, render: function (_a) {
                            var field = _a.field;
                            var onChange = field.onChange;
                            return (React.createElement(Tile, { onClick: function () {
                                    openDrawer(PaymentPermissionsDrawer, {
                                        PTCs: PTCs,
                                        preselectedPaymentIDs: paymentPermissions,
                                        hideDrawer: hideDrawer,
                                        onApply: onChange,
                                    });
                                }, grow: true, "data-testid": "payment-permissions-open-drawer-tile" },
                                React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between sui-p-2" },
                                    React.createElement(TileText, null, userPermissionsTxt),
                                    React.createElement(TileMedia, null,
                                        React.createElement(ArrowForward, null)))));
                        } })),
                React.createElement("div", { className: "sui-mt-4 sui-mb-4" },
                    React.createElement(FooterButtons, { testId: "permissionsContinueBtn", continueText: "Continue", continueHandler: continueHandler, cancelHandler: cancelHandler })))))));
};
